export default "__VITE_ASSET__Bnu0MALS__"